import BaseDelegate from './BaseDelegate';

export default class NoopDelegate extends BaseDelegate {}



// WEBPACK FOOTER //
// ./src/lib/service/delegate/NoopDelegate.js